/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useContext, useEffect} from 'react'
import { UpdateUserData } from '../../Layout/UpdateUserData/UpdateUserData'
import { UserBasicData } from '../../Layout/UserBasicData/UserBasicData'
import { userContext } from '../../UserProvider/UserProvider'
import { HeaderDashboard } from '../../UI/HeaderDashboard/HeaderDashboard'
import { Dashboard } from '../../Layout/Dashboard/Dashboard'
import { GoodInformation } from '../../UI/GoodInformation/GoodInformation'
import axios from 'axios'
import { url } from '../../ApiRoutes'
import { Header } from '../../Layout/Header/Header'


export const UserProfile = (data) => {

  const {datauser} = useContext(userContext)
  const [optionData,setOptionData]=useState('0')
  const [goodsData,setGoodsData]=useState([])
	const {user} = useContext(userContext)

  const setNumberOption = ((event)=>{
    setOptionData(event.target.value)
  })

  const config = {
    headers: { Authorization: `Bearer ${user.data.token}` }
};

  const getUsersGoods = (() => {
    axios.get(url.GetUsersGood+datauser.userName, config)
    .then(response => {
      setGoodsData(response.data.goods)
    })
  })

  useEffect(()=>{
    getUsersGoods()
  },[])

  const sizeColumn = {
    column1 : "9rem",
    column2 : "4rem",
    column3 : "9rem",
    column4 : "6rem",
    column5 : "6rem",
    column6 : "2rem",
  }

  const headerDashboardInformation = {
    columnText1 : "Placa",
    columnText2 : "Elemento",
    columnText3 : "Descripción",
    columnText4 : "Atributos",
    columnText5 : "Valor",
    columnText6 : "Ubicación",
    columnWidth1 : sizeColumn.column1,
    columnWidth2 : sizeColumn.column2,
    columnWidth3 : sizeColumn.column3,
    columnWidth4 : sizeColumn.column4,
    columnWidth5 : sizeColumn.column5,
    columnWidth6 : sizeColumn.column6,
  }
  const headerConciergeProfileInfo = {
    img : data.photo,
		imgAlt: 'UserImg',
    imgStyles: 'rounded-[100%] sm:w-[70%] lg:w-[60%]',
    names: data.names,
    lastNames: data.lastNames,
		links: [
			{
				url: '',
				name: 'Datos básicos',
			},
			{
				url: '',
				name: 'Actualizar datos',
			},
			{
				url: '',
				name: 'Sus bienes',
			},
      {
				url: '/ManageUsers',
				name: 'Volver',
			},
		]
  }

  return (
    <div>
      <div className='w-full'>
        <Header data={headerConciergeProfileInfo} setNumber={setNumberOption} />
      </div>
      <div className='w-full flex flex-col justify-center gap-[20rem] items-center'>
        <div className='w-[100%] flex justify-center items-center'>
        {optionData === '0' &&
            <UserBasicData data={datauser} />
        }
        {optionData === '1' &&
            <UpdateUserData data={datauser} />
        }
        {optionData === '2' &&
            <>
            <div className='h-screen w-screen flex justify-center gap-5 items-center flex-col'>
              <h1 className='text-[2.6rem] font-semibold'>Sus bienes</h1>
              <HeaderDashboard headerDashboardInformation={headerDashboardInformation}/>
              <Dashboard dashboardInformation={
                goodsData?.map(item=>
                  <GoodInformation goodInformation={item} sizeColumn={sizeColumn} key={item.labels}/>  
                  )}
              />
            </div>
            </>
        }
        </div>
      </div>
    </div>
  )
}
